import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';

import Brand from 'models/brand';

import { pageProps } from 'lib/analytics/page-properties';
import { BUTTON_IMPRESSION, BUTTON_CLICK } from 'lib/analytics/events';

const propTypes = {
  brand: PropTypes.instanceOf(Brand),
  app: PropTypes.string,
  trackEvent: PropTypes.func,
};

const defaultProps = {
  brand: new Brand(),
  app: '',
  trackEvent: () => {},
};

class FindParkingButton extends Component {
  constructor(props) {
    super(props);

    this.onVisibilityChange = this.onVisibilityChange.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onVisibilityChange(isVisible) {
    const { trackEvent, app } = this.props;
    if (isVisible) {
      const pageProperties = pageProps({ app });
      trackEvent({
        ...BUTTON_IMPRESSION,
        ...pageProperties,
        name: 'FindParking',
        position: '0',
      });
    }
  }

  onClick() {
    const { trackEvent, app } = this.props;
    const pageProperties = pageProps({ app });
    trackEvent({
      ...BUTTON_CLICK,
      ...pageProperties,
      name: 'FindParking',
      position: '0',
    });
  }

  render() {
    const { brand } = this.props;
    const buttonClasses = cx({
      'btn-alternate': true,
      'btn': true,
      'btn-bp': brand.isBestParking,
    });

    return (
      <div>
        <div className="find-my-space margin-top-10 hidden-lte-sm">
          <VisibilitySensor onChange={this.onVisibilityChange} partialVisibility>
            <a href="/" className={buttonClasses} onClick={this.onClick}>
              FIND MY SPACE
              <span className="iconified-font iconified-simple-magnifying-glass margin-left-10" />
            </a>
          </VisibilitySensor>
        </div>
      </div>
    );
  };
}

FindParkingButton.propTypes = propTypes;
FindParkingButton.defaultProps = defaultProps;

export default FindParkingButton;
